import HighlightDataTransformerBlock from '@activebrands/core-web/libs/storyblok/content/CmsDataTransformerBlock/HighlightDataTransformerBlock';
import { useStyletron } from '@activebrands/core-web/libs/styletron';
import getModuleBottomMarginStyles from '@activebrands/core-web/utils/style-functions/get-module-bottom-margin-styles';

interface HighlightModuleProps {
    isGrid?: boolean;
    content: any;
}

const HighlightModule = ({ isGrid = false, content, ...rest }: HighlightModuleProps) => {
    const [css] = useStyletron();

    return (
        <section
            className={css({
                ...getModuleBottomMarginStyles(isGrid),
                backgroundColor: 'var(--color-bg)',
            })}
        >
            <div
                className={css({
                    marginLeft: 'auto',
                    marginRight: 'auto',
                })}
            >
                <HighlightDataTransformerBlock content={content} {...rest} />
            </div>
        </section>
    );
};

export default HighlightModule;
